// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__13t4p","actionsCol":"EnrolledClinics_actionsCol__14P29"};